import React from 'react';
import moment from 'moment';

import CurrencySign from 'components/price/CurrencySign.component';
import fixed from 'utils/values/fixed.util';

import ProcedureReviewComponent from 'clientProfile/components/bookingHistory/ProcedureReview';
import TransactionReviewComponent from 'clientProfile/components/bookingHistory/TransactionReview';
import BookingIconComponent from 'clientProfile/components/common/BookingIcon';
import { getBookingOriginText, getStatusText } from 'clientProfile/utils';

const BookingDescription = (props) => {
  let originShowingTxt =
    props.detailsView && props.appointment.status === 'paid' && props.appointment.transaction
      ? moment(props.appointment.transaction.created).format('DD MM YYYY, HH:mm')
      : getBookingOriginText(
          props.appointment.origin,
          props.appointment.frequency,
          props.appointment.frequency_type,
          props.appointment.is_repeating,
          props.appointment.until,
        );
  let statusText = getStatusText(props.appointment.status);
  // future repeat booking
  if (props.appointment.appointment) {
    originShowingTxt = 'Booked In Salon';
    statusText = props.appointment.appointment.status;
  }
  if (props.appointment.transaction && props.appointment.transaction.is_no_show_fee) {
    originShowingTxt = 'Appointment deleted';
    statusText = 'No-show fee charged';
  }
  let boughtProduct = [];
  if (props.appointment.transaction && props.appointment.transaction.clients[0].products.length) {
    boughtProduct = props.appointment.transaction.clients[0].products;
  }
  let services = [];
  if (props.appointment.transaction) {
    props.appointment.transaction.clients.map((client) => {
      services = services.concat(client.services);
      return null;
    });
  }
  let subTotal = 0;
  const clientTransactions = props.appointment.transaction;
  if (clientTransactions && services.length) {
    services.forEach((service) => {
      subTotal += service.finalPrice;
    });
  }

  return (
    <div className="bh-item border-b">
      <header>
        <span>{statusText}</span>
        <span className="origin"> {originShowingTxt}</span>
      </header>
      <div
        className="description-click"
        onClick={() => {
          props.onAppointmentClick(props.appointment.id, props.appointment.timestamp || props.appointment.start_time);
        }}
      >
        {props.appointment.transaction && services.length ? (
          <div>
            <div className="date 1">
              {moment(props.appointment.timestamp || props.appointment.procedures[0].start_time).format(
                'ddd D MMMM YYYY, h:mm a',
              )}
            </div>
            {services.map((service, index) => (
              <TransactionReviewComponent
                key={`${index}-${props.appointment.transaction.id}-${service.id}-${service.stylistId}`}
                service={service}
                showStylist={props.detailsView}
              />
            ))}
            <div className="booking-total">
              <span> Total:</span>
              <strong>{fixed(subTotal)}</strong>
            </div>
          </div>
        ) : (
          <div>
            <div className="date 2">
              {moment(props.appointment.timestamp || props.appointment.procedures[0].start_time).format(
                'ddd D MMMM YYYY, h:mm a',
              )}
            </div>
            {props.appointment.procedures &&
              props.appointment.procedures.map((procedure) => (
                <ProcedureReviewComponent
                  key={`${props.appointment.id}-${procedure.id}`}
                  procedure={procedure}
                  showStylist={props.detailsView}
                />
              ))}
            {!props.appointment.procedures && (
              <ProcedureReviewComponent
                key={`${props.appointment.id}`}
                procedure={props.appointment}
                showStylist={props.detailsView}
              />
            )}
          </div>
        )}
      </div>
      {boughtProduct.length > 0 &&
        boughtProduct.map((p) => (
          <div style={{ display: 'flex', justifyContent: 'space-between', margin: '20px auto' }}>
            <div>{`${p.quantity} x ${p.title}`}</div>
            <div>
              <CurrencySign />
              {p.finalPrice}
            </div>
          </div>
        ))}
      {props.footer && (
        <footer>
          {props.appointment.notes && <BookingIconComponent iconName="note" />}
          {props.appointment.sms_records && !!props.appointment.sms_records.length && (
            <BookingIconComponent iconName="sms" />
          )}
          {props.goToViewDetails && (
            <span
              className="btn btn-violet-link pull-right"
              onClick={() => {
                if (props.goToViewDetails) {
                  props.goToViewDetails(props.appointment);
                }
              }}
            >
              View details
            </span>
          )}
        </footer>
      )}
    </div>
  );
};
export default BookingDescription;
